import { toast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { isMissingRepoColumns } from "./dbFixService";

export const createComponent = async (
  name: string, 
  componentTypeId: string,
  organizationId: string,
  repoType?: string,
  repoName?: string,
  repoUrl?: string,
  mainUrl?: string,
  logsUrl?: string,
  dashUrl?: string,
  swaggerUrl?: string
) => {
  try {
    // Check if repo columns exist
    const missingColumns = isMissingRepoColumns();
    
    // Create base object
    const componentData: any = {
      name: name,
      id_component_type: componentTypeId,
      id_organization: organizationId,
    };
    
    // Only add repo fields if columns exist
    if (!missingColumns) {
      componentData.repo_type = repoType || null;
      componentData.repo_name = repoName || null;
      componentData.repo_url = repoUrl || null;
      componentData.main_url = mainUrl || null;
      componentData.logs_url = logsUrl || null;
      componentData.dash_url = dashUrl || null;
      componentData.swagger_url = swaggerUrl || null;
    }
    
    const { data, error } = await supabase
      .from("components")
      .insert(componentData)
      .select()
      .single();

    if (error) {
      console.error("Erro ao criar componente:", error);
      toast({
        title: "Erro",
        description: "Não foi possível criar o componente",
        variant: "destructive",
      });
      return { success: false };
    }

    toast({
      title: "Sucesso",
      description: "Componente criado com sucesso",
    });
    return { success: true, component: data };
  } catch (error) {
    console.error("Falha ao criar componente:", error);
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao criar o componente",
      variant: "destructive",
    });
    return { success: false };
  }
};

export const updateComponent = async (
  componentId: string, 
  name: string,
  componentTypeId: string,
  repoType?: string,
  repoName?: string,
  repoUrl?: string,
  mainUrl?: string,
  logsUrl?: string,
  dashUrl?: string,
  swaggerUrl?: string
) => {
  try {
    // Check if repo columns exist
    const missingColumns = isMissingRepoColumns();
    
    // Create base object
    const updateData: any = {
      name: name,
      id_component_type: componentTypeId,
      modified_at: new Date().toISOString(),
    };
    
    // Only add repo fields if columns exist
    if (!missingColumns) {
      updateData.repo_type = repoType || null;
      updateData.repo_name = repoName || null;
      updateData.repo_url = repoUrl || null;
      updateData.main_url = mainUrl || null;
      updateData.logs_url = logsUrl || null;
      updateData.dash_url = dashUrl || null;
      updateData.swagger_url = swaggerUrl || null;
    }
    
    const { error } = await supabase
      .from("components")
      .update(updateData)
      .eq("id", componentId);

    if (error) {
      console.error("Erro ao atualizar componente:", error);
      toast({
        title: "Erro",
        description: "Não foi possível atualizar o componente",
        variant: "destructive",
      });
      return false;
    }

    toast({
      title: "Sucesso",
      description: "Componente atualizado com sucesso",
    });
    return true;
  } catch (error) {
    console.error("Falha ao atualizar componente:", error);
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao atualizar o componente",
      variant: "destructive",
    });
    return false;
  }
};

export const deleteComponent = async (componentId: string) => {
  try {
    const { error } = await supabase
      .from("components")
      .delete()
      .eq("id", componentId);

    if (error) {
      console.error("Erro ao excluir componente:", error);
      toast({
        title: "Erro",
        description: "Não foi possível excluir o componente",
        variant: "destructive",
      });
      return false;
    }

    toast({
      title: "Sucesso",
      description: "Componente excluído com sucesso",
    });
    return true;
  } catch (error) {
    console.error("Falha ao excluir componente:", error);
    toast({
      title: "Erro",
      description: "Ocorreu um erro ao excluir o componente",
      variant: "destructive",
    });
    return false;
  }
};
